export const EMAIL_ALREADY_TAKEN = "UserEmailAlreadyTaken";
export const EMAIL_DEACTIVATED = "UserEmailDeactivated";
export const EMAIL_DOES_NOT_BELONG_TO_ACTIVE_USER = "EmailDoesNotBelongToActiveUser";
export const AUTH_CODE_ERROR = "AuthCodeError";
export const USER_IS_LOCKED = "UserIsLocked";
export const CODE_GENERATION_UNAVAILABLE = "CodeGenerationUnavailable";
